import { createAction, props } from '@ngrx/store';
import { ConfigTypes } from '../../enums/config-type.enum';
import { SnippetProfileListType } from '../../enums/profile-list-type.enum';
import { ConfigData, SnippetProfileList } from '../../interfaces/config-data.interface';
import { DocumentSaveInitData } from '../../interfaces/document-init-data.interface';
import { IPermissionOptions } from '../../interfaces/permission-options.interface';

export const getConfigs = createAction('[Config] Get all available org units');
export const addConfig = createAction('[Config] Set org units', props<{ payload: { data: any; type: ConfigTypes } }>());
export const updateLocalConfigs = createAction('[Config] Update local org units', props<{ list: ConfigData<any>[] }>());
export const getPermissionOptions = createAction('[Config] Get permission options');
export const getPermissionOptionsSuccess = createAction(
    '[Config] Get permission options success',
    props<{ list: IPermissionOptions }>()
);

export const getProfileList = createAction('[Config] Get Profile List', props<{ listType: SnippetProfileListType }>());
export const getProfileListSuccess = createAction(
    '[Config] Get Profile List Success',
    props<{ listType: SnippetProfileListType; data: SnippetProfileList<any>[] }>()
);
export const addProfileList = createAction(
    '[Config] Add Profile List',
    props<{ listType: SnippetProfileListType; data: any }>()
);
export const updateProfileList = createAction(
    '[Config] Update Profile List',
    props<{ listType: SnippetProfileListType; entityId: string; data: any }>()
);
export const deleteProfileList = createAction(
    '[Config] Delete Profile List',
    props<{ listType: SnippetProfileListType; entityId: string }>()
);

// Saved Init Data List
export const getSavedInitDataListForDocument = createAction(
    '[Config] Get Saved Init Data List for Document',
    props<{ docFavId: string }>()
);
export const getSavedInitDataListForDocumentSuccess = createAction(
    '[Config] Get Saved Init Data List for Document Success',
    props<{ docFavId: string; initDataList: ConfigData<DocumentSaveInitData>[] }>()
);
export const setActiveInitDataForDocument = createAction(
    '[Config] Set active Init Data for Document',
    props<{ initData: ConfigData<DocumentSaveInitData> }>()
);
export const addInitDataForDocument = createAction(
    '[Config] Add Init Data for Document',
    props<{ docFavId: string; initData: DocumentSaveInitData }>()
);
export const updateInitDataForDocument = createAction(
    '[Config] Update Init Data for Document',
    props<{ initDataList: ConfigData<DocumentSaveInitData> }>()
);
export const deleteInitDataForDocument = createAction(
    '[Config] Delete Init Data for Document',
    props<{ initDataList: ConfigData<DocumentSaveInitData> }>()
);
